// Start text with a capital letter.
export const capitalizeFirstCharacter = (text: string) => {
  return text[0].toUpperCase() + text.slice(1)
}
